import axiosInstance from "./axios";

const post = (url, params) => {
  axiosInstance.post(url, { ...params });
};

export default post;
